<h1 mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>Kørende partner</h1>
<button class="btn-close btn-icon" mat-dialog-close title="Luk dialog">
  <mat-icon class="material-icons">close</mat-icon>
</button>

<div mat-dialog-content>
  <div>
    @if (hasUpcomingPartner) {
      <div class="orange align-center margin--bottom-l">
        <div><mat-icon class="icon-48" svgIcon="obs-solid"></mat-icon></div>
        <div>
          Bemærk: Der er allerede et fremtidigt partnerskift til {{ upcomingPartner }} pr {{ partnerValidFrom | date : 'dd.MM.yyyy' }}. Laves
          der et nyt skifte, vil dette blive overskrevet.
        </div>
      </div>
    }
    @if (activeOrderCount > 0) {
      <div class="orange align-center margin--bottom-l">
        <div><mat-icon class="icon-48" svgIcon="obs-solid"></mat-icon></div>
        <div>Bemærk: Aftalen har {{ activeOrderCount }} aktiv(e) ordre pr valgte opsigelsesdato</div>
      </div>
    }
    <form [formGroup]="form" autocomplete="off">
      <div class="form-row">
        <app-partner-active-input
          [form]="form"
          [partners]="activepartners"
          [produktId]="serviceaftale.serviceAbonnement.product.id"
        ></app-partner-active-input>
      </div>
      <div class="form-row">
        <mat-form-field appearance="outline" color="primary">
          <mat-label>Skift træder i kraft</mat-label>
          <input #input matInput [matDatepicker]="picker" formControlName="validFrom" [min]="today" />
          <mat-datepicker-toggle matPrefix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
          <mat-hint>
            dd+n eller dd-n kan bruges i dette felt.
            <br />
            F.eks. dd+14 vil give en dato som er 14 dage fra dags dato.
          </mat-hint>
        </mat-form-field>
      </div>
      <div class="form-row">
        <app-info
          tooltip="En note der automatisk sendes med til partner (OK Energiteknik eller ekstern partner) på såvel tilkald som eftersyn."
        ></app-info>
        <mat-form-field appearance="outline" class="mdc-textarea-fix">
          <mat-label>Fast note til s-partner/tekniker</mat-label>
          <textarea id="fastOrdreNote" formControlName="fastOrdreNote" rows="5" matInput></textarea>
          <mat-hint align="end">
            <app-character-count [control]="fastOrdreNote" maxlength="500"></app-character-count>
          </mat-hint>
          @if (fastOrdreNote.hasError('maxlength')) {
            <mat-error>
              Fast note til s-partner/tekniker må højest være 500 karakterer lang
            </mat-error>
          }
        </mat-form-field>
      </div>
    </form>
  </div>

  <div mat-dialog-actions class="row-reverse">
    <button mat-raised-button color="primary" (click)="save()" [disabled]="form.invalid">Gem</button>
    <button (click)="cancel()" class="modal-cancel" mat-raised-button>Fortryd</button>
  </div>
</div>
